import Model from './interface/Model'
import Api from './Api'
import WebMessage from './WebMessage'

type RemoteConnMetadata = {
  apply_device_targeting?: boolean // use when when driver is freewheel
  creative?: {
    width: number
    height: number
  }
  open_measurement?: Array<string>
  team_ids?: Array<string>
  content_targeting?: {
    include_bundle: Array<string>
  }
  custom_targeting?: string
}

export default class RemoteConnection extends Model {
  protected api_settings = {
    save_mode: 'post',
    paths: {
      singular: 'remote_connections' as string | null,
      plural: 'remote_connections' as string | null,
    },
  }

  public id: any = null

  public name: string = ''

  public code: string = ''

  public driver: string = ''

  public username: string = ''

  public password: string = ''

  public credentials_file: any = null

  public network_id: any = null

  public type: any = 'direct_connection'

  public metadata: RemoteConnMetadata = {
    apply_device_targeting: false,
    creative: {
      width: 0,
      height: 0,
    },
    open_measurement: [],
    team_ids: [],
    content_targeting: {
      include_bundle: [],
    },
    custom_targeting: '',
  }

  public get apiData() {
    return {
      id: this.id,
      name: this.name,
      code: this.code,
      driver: this.driver,
      username: this.username,
      password: this.password,
      metadata: this.metadata,
      credentials_file: this.credentials_file,
      network_id: this.network_id,
      type: this.type,
    }
  }

  public static types: any = [
    {
      name: 'Direct Connection',
      value: 'direct_connection',
    },
    {
      name: 'Adserver',
      value: 'adserver',
    },
  ]

  public static drivers: any = [
    {
      name: 'Google AdManager',
      value: 'gam',
    },
    {
      name: 'Freewheel',
      value: 'freewheel',
    },
  ]

  public onSave(response: any) {
    WebMessage.success(`${response.data.result.name.toUpperCase()} has been saved`)

    return response
  }

  public onError(error: any) {
    return error
  }

  public async save(credentials_file: any = null) {
    const api = new Api(true)

    let data: any = this.apiData

    if (credentials_file) {
      data.credentials_file = credentials_file
    } else {
      delete data.file
    }

    let form_data = new FormData()

    Object.keys(data).forEach(key => {
      if (key === 'metadata') {
        form_data.append(key, JSON.stringify(data[key]))
      } else {
        form_data.append(key, data[key])
      }
    })
    const id = this.id && this.id.length ? `/${this.id}` : ''
    return api
      .form(`remote_connections${id}`, form_data)
      .then(this.onSave)
      .catch(err => {
        this.onError(err)
        return err
      })
  }
}
